<template>
  <el-dialog
      title="经营者信息"
      width="1000px"
      destroy-on-close
      :visible.sync="showDialog"
      :before-close="handleClose">
    <div>
      <el-form :model="form" :rules="rules" ref="form" label-width="156px">

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="经营者全称" prop="fullName">
              <el-input style="width: 100%" type="text" placeholder="请输入经营者全称" maxlength="100"
                        v-model="form.fullName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="经营许可证号" prop="bizLicenseNumber">
              <el-input style="width: 100%" type="text" placeholder="请输入经营许可证号" maxlength="50"
                        v-model="form.bizLicenseNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="经营者社会信用代码" prop="contractEntityCode">
              <el-input style="width: 100%" type="text" placeholder="请输入签约主体统一社会信用代码" maxlength="100"
                        v-model="form.contractEntityCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="经营者企业名称" prop="contractEntityName">
              <el-input style="width: 100%" type="text" placeholder="请输入经营者企业名称" maxlength="100"
                        v-model="form.contractEntityName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="经营许可证经营范围" prop="bizLicenseScope">
              <el-input type="textarea" placeholder="请输入经营许可证经营范围" maxlength="500"
                        v-model="form.bizLicenseScope"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="核发日期" prop="dateOfIssue">
              <el-date-picker
                  style="width: 100%"
                  v-model="form.dateOfIssue"
                  type="date"
                  value-format="timestamp"
                  placeholder="请选择核发日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="有效期起" prop="dateOfStart">
              <el-date-picker
                  style="width: 100%"
                  v-model="form.dateOfStart"
                  type="date"
                  value-format="timestamp"
                  placeholder="请选择有效期起">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="有效期止" prop="dateOfEnd">
              <el-date-picker
                  style="width: 100%"
                  v-model="form.dateOfEnd"
                  type="date"
                  value-format="timestamp"
                  placeholder="请选择有效期起">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="通讯地址" prop="address">
              <el-input style="width: 100%" type="text" placeholder="请输入通讯地址" maxlength="100"
                        v-model="form.address"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="属地代码（县区）" prop="codeOfDivision">
              <el-input style="width: 100%" type="text" placeholder="请输入属地代码（县区）" maxlength="100"
                        v-model="form.codeOfDivision"></el-input>
            </el-form-item>
          </el-col>
          
          <el-col :span="12">
            <el-form-item label="负责人姓名" prop="director">
              <el-input style="width: 100%" type="text" placeholder="请输入负责人姓名" maxlength="100"
                        v-model="form.director"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="负责人联系方式" prop="directorTel">
              <el-input style="width: 100%" type="text" placeholder="请输入负责人联系方式" maxlength="50"
                        v-model="form.directorTel"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="协议生效日期" prop="dateAgreementStart">
              <el-date-picker
                  style="width: 100%"
                  v-model="form.dateAgreementStart"
                  type="date"
                  value-format="timestamp"
                  placeholder="请选择协议生效日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="有效期止" prop="dateAgreementEnd">
              <el-date-picker
                  style="width: 100%"
                  v-model="form.dateAgreementEnd"
                  type="date"
                  value-format="timestamp"
                  placeholder="请选择协议终止日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="协议是否终止" prop="endingAgreement">
              <el-radio-group v-model="form.endingAgreement">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="平台协议" prop="platformAgreementPdf">
              <upload_pdfs
                  :max="1"
                  @update:urls="updateUrls"
                  :urls.sync="form.platformAgreementPdf">
              </upload_pdfs>
            </el-form-item>

          </el-col>

        </el-row>


      </el-form>


    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="onsubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import upload_pdfs from "@/components/pdf/upload_pdfs";

export default {
  name: "supervise",
  components: {
    upload_pdfs
  },

  data() {
    return {
      showDialog: false,
      form: {
        fullName: "",
        bizLicenseNumber: "",
        bizLicenseScope: "",
        dateOfIssue: "",
        dateOfStart: "",
        dateOfEnd: "",
        address: "",
        codeOfDivision: "",
        contractEntityCode: "",
        contractEntityName: "",
        director: "",
        directorTel: "",
        dateAgreementStart: "",
        dateAgreementEnd: "",
        platformAgreementPdf: [],
        endingAgreement: 2,
      },
      rules: {
        fullName: [{required: true, message: '请输入经营者全称', trigger: ['blur', 'change']}],
        bizLicenseNumber: [{required: true, message: '请输入经营许可证号', trigger: ['blur', 'change']}],
        bizLicenseScope: [{required: true, message: '请输入经营许可证经营范围', trigger: ['blur', 'change']}],
        dateOfIssue: [{required: true, message: '请选择核发日期', trigger: ['blur', 'change']}],
        dateOfStart: [{required: true, message: '请选择有效期起', trigger: ['blur', 'change']}],
        dateOfEnd: [{required: true, message: '请选择有效期止', trigger: ['blur', 'change']},
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请选择有效期止'))
              } else if (value <= this.form.dateOfStart) {
                callback(new Error('有效结束时间请大于开始有效时间!'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }],

        address: [{required: true, message: '请输入通讯地址', trigger: ['blur', 'change']}],
        codeOfDivision: [{required: true, message: '请输入属地代码（县区）', trigger: ['blur', 'change']}],
        contractEntityCode: [{required: true, message: '请输入签约主体统一社会信用代码', trigger: ['blur', 'change']}],
        contractEntityName: [{required: true, message: '请输入签约主体名称', trigger: ['blur', 'change']}],
        director: [{required: true, message: '请输入负责人姓名', trigger: ['blur', 'change']}],
        directorTel: [{required: true, message: '请输入负责人联系方式', trigger: ['blur', 'change']}],


        dateAgreementStart: [{required: true, message: '请选择协议生效日期', trigger: ['blur', 'change']}],
        dateAgreementEnd: [{required: true, message: '请选择协议终止日期', trigger: ['blur', 'change']},
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请选择有效期止'))
              } else if (value <= this.form.dateAgreementStart) {
                callback(new Error('终止日期请大于生效日期!'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }],
        platformAgreementPdf: [{required: true, message: '请上传平台协议', trigger: ['blur', 'change']}],
        endingAgreement: [{required: true, message: '请选择协议是否终止', trigger: ['blur', 'change']}],


      }
    }
  },

  props: {
    superviseId: {
      default: ''
    },
    value: {
      default: false
    }
  },
  watch: {
    value() {

      this.showDialog = this.value
      !this.showDialog && this.handleClose()
      this.showDialog && this.getInitMerchantFn()
    }
  },
  methods: {
    async getInitMerchantFn() {
      const {code, data} = await this.$axios.get('/api/v1/manage/organization/survey/merchant/' + this.superviseId)
      if (code === 1 && data) {
        this.form = {
          ...this.form,
          ...data,
          dateOfIssue: new Date(data.dateOfIssue).getTime(),
          dateOfStart: new Date(data.dateOfStart).getTime(),
          dateOfEnd: new Date(data.dateOfEnd).getTime(),
          dateAgreementStart: new Date(data.dateAgreementStart).getTime(),
          dateAgreementEnd: new Date(data.dateAgreementEnd).getTime(),
          platformAgreementPdf: [{url: data.platformAgreementPdf, name: data.platformAgreementPdf}]
        }
      }
    },
    updateUrls() {
      this.$refs.form.validateField('platformAgreementPdf')
    },
    handleClose() {
      this.form = {
        fullName: "",
        bizLicenseNumber: "",
        bizLicenseScope: "",
        dateOfIssue: "",
        dateOfStart: "",
        dateOfEnd: "",
        address: "",
        codeOfDivision: "",
        contractEntityCode: "",
        contractEntityName: "",
        director: "",
        directorTel: "",
        dateAgreementStart: "",
        dateAgreementEnd: "",
        platformAgreementPdf: [],
        endingAgreement: 2,
      }
      this.$emit('input', false)
    },
    onsubmit() {
      console.log(this.form, 111);
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const url = '/api/v1/manage/organization/survey/merchant'
          const params = {
            ...this.form,
            platformAgreementPdf: this.form.platformAgreementPdf[0].url,
            dateOfIssue: this.$utils.timeFn(this.form.dateOfIssue, 'YYYY-MM-DD'),
            dateOfStart: this.$utils.timeFn(this.form.dateOfStart, 'YYYY-MM-DD'),
            dateOfEnd: this.$utils.timeFn(this.form.dateOfEnd, 'YYYY-MM-DD'),
            dateAgreementStart: this.$utils.timeFn(this.form.dateAgreementStart, 'YYYY-MM-DD'),
            dateAgreementEnd: this.$utils.timeFn(this.form.dateAgreementEnd, 'YYYY-MM-DD'),
            organizationId:this.superviseId,
          }
          const {code} = await this.$axios.post(url, params)
          if (code === 1) {
            this.$message.success('操作成功')
            this.handleClose()
          }
        } else {
          this.$message.warning("请检查表单数据是否输入正确！");
          return false;
        }
      });
    }
  }
}
</script>

<style scoped>

</style>